import { createRoute, redirect } from "@tanstack/react-router";
import { landingPath } from "@/app/nav";
import { NoAccessPage } from "@/components/pages";
import { staffRoute } from "@/routes/staff";

export const homeRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/",
  beforeLoad: ({ context }) => {
    const target = landingPath(context.session.can);
    if (target) throw redirect({ to: target });
  },
  component: NoAccessPage,
});
